import { render, staticRenderFns } from "./Companies.list.vue?vue&type=template&id=ae963cf2&"
import script from "./Companies.list.vue?vue&type=script&lang=js&"
export * from "./Companies.list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports